import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

const Banner = () => {
  const slides = [
    {
      desktop: "https://i.ibb.co.com/8LFqTbvY/ebay-desktop.avif",
      mobile: "https://i.ibb.co.com/qYtRqLrY/ebay-mobile.avif",
    },
    {
      desktop:
        "https://i.ibb.co.com/cSgPVPdw/Freshefy-air-freshener-desktop.jpg",
      mobile: "https://i.ibb.co.com/B2VGJ1cD/freshefy-air-freshener-Mobile.jpg",
    },
    {
      desktop: "https://i.ibb.co/DfyZvND8/Deodorants-for-All.webp",
      mobile: "https://i.ibb.co/zW4jHDwb/Untitled-design-3.png",
    },
    {
      desktop: "https://i.ibb.co.com/qL8cvndz/freshify.jpg",
      mobile: "https://i.ibb.co/zW4jHDwb/Untitled-design-3.png",
    },
    {
      desktop: "https://i.ibb.co.com/Y4wp3vwm/all-emaar-1.jpg",
      mobile: "https://i.ibb.co/zW4jHDwb/Untitled-design-3.png",
    },
  ];

  return (
    <div className="w-full overflow-hidden">
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        loop={true}
        speed={1200}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        className="w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <picture>
              <source media="(max-width: 700px)" srcSet={slide.mobile} />
              <img
                src={slide.desktop}
                alt={`Banner ${index + 1}`}
                className="w-full min-h-[500px] object-cover"
              />
            </picture>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;
